import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFunctions } from "firebase/functions";

// Your Firebase configuration object
const firebaseConfig = {
  apiKey: "AIzaSyAWV1MinDvwqYwh2pQBVcv60ta81G79C0w",
  authDomain: "tanzania-road-safety.firebaseapp.com",
  projectId: "tanzania-road-safety",
  storageBucket: "tanzania-road-safety.firebasestorage.app", // Corrected to the bucket that accepted the CORS update
  messagingSenderId: "526686888458",
  appId: "1:526686888458:web:338a67c94d3ed1248775f3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Export all services from a single statement
export { db, auth, storage, functions };
